<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <span>服务费记录</span>
        </div>
      </template>

      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>商户编号</span>
          <a-input v-model.trim="paramsData.merchantNo" allow-clear placeholder="请输入商户编号" style="width: 200px"/>
        </div>
        <div class="item">
          <span>状态</span>
          <a-select v-model.trim="paramsData.paymentStatus" allow-clear placeholder="请选择状态" style="width: 150px">
            <a-select-option v-for="(item, key) in taxDict.serviceFeeStatus" :key="key" :value="Number(key)">{{ item.label }}</a-select-option>
          </a-select>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 操作按钮区域 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.id"
          >
            <template slot="feeAmount" slot-scope="text">
              <Balance :amount="text" prefix="￥"></Balance>
            </template>
            <template slot="paymentStatus" slot-scope="text, record">
              <a-popover v-if="record.failReason" title="失败原因">
                <template #content>{{ record.failReason }}</template>
                <a-tag :color="taxDict.serviceFeeStatus[text]?.color || 'default'">
                  {{ taxDict.serviceFeeStatus[text]?.label || text }}
                </a-tag>
              </a-popover>
              <a-tag v-else :color="taxDict.serviceFeeStatus[text]?.color || 'default'">
                {{ taxDict.serviceFeeStatus[text]?.label || text }}
              </a-tag>
            </template>
            <template slot="settleTime" slot-scope="text">
              {{ formatDateTime(text) }}
            </template>
            <template slot="sfAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.accountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="sfOppAccountNo" slot-scope="text, record">
              <WalletInfo :account-name="record.oppAccountName" :account-no="text" :show-account-name="true" :show-account-no="true"/>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button
                  v-if="record.paymentStatus !== 2 && $authority('serviceFeeRetry')"
                  icon="redo"
                  size="small"
                  type="link"
                  @click="retryBtn(record)"
              >
                重试
              </a-button>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="paginationBox">
        <LcfsPagination
            :fn="getTableData"
            :page-no.sync="pagination.pageNo"
            :page-size.sync="pagination.pageSize"
            :total="pagination.total"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import {message} from "ant-design-vue";
import LcfsPagination from "@/view/components/LcfsPagination.vue";
import Balance from "@/view/components/Balance.vue";
import WalletInfo from "@/view/components/WalletInfo.vue";
import {taxDict} from '@/utils/bizDict/taxDict';

export default {
  name: 'TaxServiceFee',
  components: {LcfsPagination, Balance, WalletInfo},
  data() {
    return {
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      tableData: [],

      paramsData: {
        merchantNo: '',
        paymentStatus: null,
      },

      taxDict,

      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 60
        },
        {
          title: "订单号",
          dataIndex: "orderNo",
          align: "center",
          width: 180
        },
        {
          title: "商户编号",
          dataIndex: "merchantNo",
          align: "center",
          width: 120
        },
        {
          title: "商户名称",
          dataIndex: "merchantName",
          align: "center",
          width: 150
        },
        {
          title: "付款账户",
          dataIndex: "accountNo",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'sfAccountNo'}
        },
        {
          title: "收款账户",
          dataIndex: "oppAccountNo",
          align: "center",
          width: 180,
          scopedSlots: {customRender: 'sfOppAccountNo'}
        },
        {
          title: "金额",
          dataIndex: "feeAmount",
          align: "center",
          width: 100,
          scopedSlots: {customRender: 'feeAmount'}
        },
        {
          title: "支付状态",
          dataIndex: "paymentStatus",
          align: "center",
          width: 80,
          scopedSlots: {customRender: 'paymentStatus'}
        },
        {
          title: "结算时间",
          dataIndex: "settleTime",
          align: "center",
          width: 160,
          scopedSlots: {customRender: 'settleTime'}
        },
        {
          title: "操作",
          key: "action",
          width: 80,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ]
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    formatDateTime(dateTime) {
      if (!dateTime) return '-';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('zh-CN');
      } catch (e) {
        return dateTime;
      }
    },

    async getTableData() {
      try {
        const res = await this.api.getServiceFeeList({
          ...this.paramsData,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        message.error("获取数据失败");
      }
    },

    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        merchantNo: '',
        paymentStatus: null,
      };
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    async retryBtn(record) {
      try {
        const res = await this.api.retryServiceFee({
          orderNo: record.orderNo
        });
        if (res.code === 200) {
          message.success("重试成功");
          this.getTableData();
        } else {
          message.warning(res.info || "重试失败");
        }
      } catch (error) {
        console.error("重试失败:", error);
        message.error("重试失败");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.top-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 16px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;
  }
}

.paginationBox {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>